import { envConfig } from '#constants/envConfig';

export type NativePlatform = 'ios' | 'android' | 'web';

/**
 * Concrete runtime platform of the native shell. 'web' in the browser build.
 * Gated on IS_NATIVE so the web build tree-shakes the @capacitor/core import away.
 */
export async function getNativePlatform(): Promise<NativePlatform> {
  if (!envConfig.IS_NATIVE) {
    return 'web';
  }
  try {
    const { Capacitor } = await import('@capacitor/core');
    const platform = Capacitor.getPlatform();
    return platform === 'ios' ? 'ios' : platform === 'android' ? 'android' : 'web';
  } catch {
    return 'web';
  }
}

/**
 * Push-token platform tag the backend expects (PushPlatform enum: WEB/ANDROID/IOS).
 * Drives delivery: WEB → data-only via service worker, ANDROID → FCM notification,
 * IOS → direct APNs (see PushSenderService).
 */
export async function getPushPlatform(): Promise<'IOS' | 'ANDROID' | 'WEB'> {
  const platform = await getNativePlatform();
  return platform === 'ios' ? 'IOS' : platform === 'android' ? 'ANDROID' : 'WEB';
}
